import { Checkbox, Form } from 'antd';

import { AggregatedProductIdentity } from 'codegen';

const { useWatch, useFormInstance, Item } = Form;

export const ThresholdCheckbox = () => {
  const form = useFormInstance();
  const type = useWatch('type', form);
  const checked = useWatch('hasAutoCalculatedThresholds', form);

  const isTypeSKU = type === AggregatedProductIdentity.type.SKU;
  const isTypeAI = type === AggregatedProductIdentity.type.AI;

  return (
    <Item name='hasAutoCalculatedThresholds' className='mb-0 mt-7'>
      <Checkbox
        disabled={isTypeSKU || isTypeAI}
        checked={checked}
        onChange={(e) => {
          form.setFieldsValue({ hasAutoCalculatedThresholds: e.target.checked });

          if (e.target.checked) {
            form.resetFields(['fullMatchThreshold', 'partialMatchThreshold']);
            form.setFieldValue('partialMatchThreshold', undefined);
            form.setFieldValue('fullMatchThreshold', undefined);
          }
        }}
      >
        Auto
      </Checkbox>
    </Item>
  );
};
